import * as React from "react";
import { isEmpty as _isEmpty, isEqual as _isEqual, get as _get } from "lodash";
import { ILabTest } from "../../../models/patients/IConfigBasedPrescription";
import { FormItemMode } from "../../../utils/AppConstants";
import AppUtils from "../../../utils/AppUtils";

export interface PatientLabTestsViewProps {
    data: ILabTest;
    index: number
    allData: { item: any, mode: FormItemMode }[];
}

class PatientLabTestsView extends React.Component<PatientLabTestsViewProps> {

    constructor(props: PatientLabTestsViewProps) {
        super(props);
    }

    render() {
        const { data } = this.props;
        const itemIndex = this.props.allData.findIndex((obj: any) => {
            return data.code
                ? _isEqual(obj.item.code, data.code)
                : _isEqual(_get(obj.item, "diagnosis.displayValue", "").toLowerCase(), data.diagnosis.displayValue.toLowerCase())
        })
        const isDuplicate = itemIndex !== this.props.index;
        const isMobile: boolean = AppUtils.getIsMobile();
        return (
            <div className={`patient-labTest-view list-view-template ${isDuplicate ? "is-duplicate" : ""} ${isMobile ? "mobile" : ""}`}>
                <div className="header-container">
                    <div className="header-tag">
                        <div className="name">
                            {(data.diagnosis as any).displayValue}
                            {data.diagnosis && (data.diagnosis as any).additionalInfo && (data.diagnosis as any).additionalInfo.subProducts.length > 0 &&
                                <React.Fragment>
                                    &nbsp;({(data.diagnosis as any).additionalInfo.subProducts.length})
                                </React.Fragment>
                            }
                        </div>
                        {/*<div className="labTest-instructions">{this.props.data.code}</div>*/}
                    </div>
                    <div className={"meta-container"}>
                        {!_isEmpty(data.labTestFrequency) && <div className={"meta-item"}>{`${data.labTestFrequency.count || ""} ${data.labTestFrequency.unit === "Stat" ? "Immediate" : data.labTestFrequency.unit}`}</div>}
                        {!_isEmpty(data.instructions) && <div className={"meta-item"}>{data.instructions}</div>}
                        {!_isEmpty(data.comments) && <div className={"meta-item"}>{data.comments}</div>}
                    </div>
                </div>
                <div className={"description-container"}>
                    {data.diagnosis && (data.diagnosis as any).additionalInfo && (data.diagnosis as any).additionalInfo.subProducts &&
                        (data.diagnosis as any).additionalInfo.subProducts.map((subProduct: any) => subProduct.name).join(", ")
                    }
                </div>
            </div>
        );
    }
}

export default PatientLabTestsView;